<template>
  <div class="container">
    <div id="gallery">
      <!-- <h1 class="header-title text-center">Das Studio</h1>
      <p class="text-center sub-title mx-auto w-75">
        Hier entstehen Aufnahmen für unsere spannenden Hörbücher. In
        Wohlfühlatmosphäre und bester Aufnahmequalität.
      </p> -->
      <div ref="galleryItems" v-if="!viewStore.isMobile">
        <div class="row appear">
          <div class="col-8">
            <div class="block bg-light shadow">
              <div class="px-0">
                <img
                  class="w-100 rounded-3"
                  src="../assets/images/studio_2.jpg"
                  alt=""
                />
                <!-- <div
                  class="position-absolute bottom-0 start-50 translate-middle-x w-100 background-filter rounded-3"
                >
                  <div class="space-top text-white ps-4 w-50">
                    <span class="fw-bolder fs-5">Der Aufnahmeraum</span> <br />
                    Verbindet Wohlffühlen und brilliante Raumakustik
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col taggy align-self-center">
            <div
              class="text-center fw-normal taggy-font taggy-header rotation-1"
            >
              Bright
            </div>
            <div class="text-center">
              <div class="ps-1">ambience</div>
              <!-- <div class="ps-1">atmo</div>
              <div class="ps-1">sound</div> -->
            </div>
          </div>
        </div>

        <div class="row appear space-vert">
          <div class="col taggy text-start align-self-center">
            <div
              class="text-start fw-normal taggy-font taggy-header rotation-2 ps-3"
            >
              Bright
            </div>
            <div class="text-end tags-color">
              <!-- <div class="ps-5">ideas</div> -->
              <div class="ps-5">ideas</div>
              <!-- <div class="ps-5">sound</div> -->
            </div>
          </div>
          <div class="col-8">
            <div class="block bg-light shadow">
              <div class="px-0">
                <img
                  class="w-100 rounded-3"
                  src="../assets/images/studio_4.jpg"
                  alt=""
                />
                <!-- <div
                  class="position-absolute bottom-0 start-50 translate-middle-x w-100 background-filter rounded-3"
                >
                  <div class="space-top2 text-white ps-4 w-100">
                    <span class="fw-bolder fs-5">Pause für Stimme & Kopf</span>
                    <br />
                    Die gemütliche und stylische Lounge für mehr
                    Wohlfühlatmosphäre zwischen den Aufnahmen
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="row appear">
          <div class="col-8">
            <div class="block bg-light shadow">
              <div class="px-0">
                <img
                  class="w-100 rounded-3"
                  src="../assets/images/studio_3.jpg"
                  alt=""
                />
                <!-- <div
                  class="position-absolute bottom-0 start-50 translate-middle-x w-100 background-filter rounded-3"
                >
                  <div class="space-top text-white text-end ps-4 w-100">
                    <span class="fw-bolder fs-5">Equipment</span>
                    <br />
                    High End Qualität für perfekte Aufnahmen.
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col taggy text-start align-self-center">
            <div
              class="text-center fw-normal taggy-font taggy-header rotation-1 ps-3"
            >
              Bright
            </div>
            <div class="text-center">
              <!-- <div class="ps-1">ideas</div>
              <div class="ps-1">atmo</div> -->
              <div class="ps-1">sound</div>
            </div>
          </div>
        </div>

        <!-- <div class="row my-5 bg-light rounded-3 w-75 ms-auto appear shadow">
          <div class="col d-flex align-self-end gallery-text text-end p-3">
            Pause für Stimme & Kopf - Die gemütliche und stylische Lounge für
            mehr Wohlfühlatmosphäre zwischen den Aufnahmen
          </div>
          <div class="col-9 px-0">
            <img
              class="img-fluid rounded-end-3"
              src="../assets/images/studio_4.jpg"
              alt=""
            />
          </div>
        </div>

        <div class="row mt-5 bg-light rounded-3 w-75 appear shadow">
          <div class="col-9 px-0">
            <img
              class="img-fluid rounded-start-3"
              src="../assets/images/studio_3.jpg"
              alt=""
            />
          </div>
          <div class="col d-flex align-self-end gallery-text">
            High End Qualität für perfekte Aufnahmen.
          </div>
        </div> -->
      </div>
      <div v-else>
        <div class="row">
          <div>
            <img
              class="img-fluid rounded-3"
              src="../assets/images/studio_2.jpg"
              alt=""
            />
          </div>

          <div class="fs-6 pt-3">
            Der Aufnahmeraum: Verbindet Wohlffühlen und brilliante Raumakustik
          </div>
        </div>

        <div class="row py-5">
          <div>
            <img
              class="img-fluid rounded-3"
              src="../assets/images/studio_4.jpg"
              alt=""
            />
          </div>
          <div class="fs-6 pt-3">
            Pause für Stimme & Kopf - Die gemütliche und stylische Lounge für
            mehr Wohlfühlatmosphäre zwischen den Aufnahmen
          </div>
        </div>

        <div class="row">
          <div>
            <img
              class="img-fluid rounded-3"
              src="../assets/images/studio_3.jpg"
              alt=""
            />
          </div>
          <div class="fs-6 pt-3">High End Qualität für perfekte Aufnahmen.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "/stores/ViewStore";

const viewStore = useViewStore();
const galleryItems = ref();

onMounted(() => {
  const items = document.querySelectorAll(".appear");

  const active = function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("inview");
      } else {
        entry.target.classList.remove("inview");
      }
    });
  };
  const io2 = new IntersectionObserver(active);
  for (let i = 0; i < items.length; i++) {
    io2.observe(items[i]);
  }
});
</script>

<style scoped>
#gallery {
  padding: 5rem 0;
}

.space-vert {
  padding: 6rem 0;
}

.space-top {
  padding: 6rem 2rem 1.5rem 2rem;
}

.space-top2 {
  padding: 10rem 2rem 1.5rem 2rem;
}

.block {
  position: relative;
  width: 100%;
  height: 100%;
}

.background-filter {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgb(0, 0, 0, 0.9) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.gallery-text {
  font-size: 1.25rem;
  font-weight: 400;
  /* padding-bottom: 5rem; */
}

.appear {
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
  opacity: 0;
  -webkit-transform: translateY(20px);
  transform: translateY(20px);
}

.appear.inview {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}

.appear.inview:nth-child(1) {
  -webkit-transition-delay: 0.1s;
  transition-delay: 0.1s;
}

.appear.inview:nth-child(2) {
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}

.appear.inview:nth-child(3) {
  -webkit-transition-delay: 0.3s;
  transition-delay: 0.3s;
}

.taggy {
  font-size: 4rem;
  font-weight: 900;
}

.taggy-header {
  font-size: 5rem;
}

.rotation-1 {
  /* transform: rotate(30deg); */
}

.rotation-2 {
  transform: rotate(-30deg);
}

.tags-color {
  /* color: rgb(89, 0, 255); */
  /* color: rgb(77, 77, 77); */
}
</style>
